import * as React from 'react'

import { tsxl } from '../../Other/Translation'
import Button, { ButtonType } from '../common/Button/Button'

export interface CustomerChangerPropsInterface {
  action?: () => void
}

export class CustomerChanger extends React.Component<CustomerChangerPropsInterface, any> {
  public render(): JSX.Element {
    const self = this

    return (
      <div className="CustomerChange">
        <Button
          automation="change-customer-button"
          label={tsxl('Customer.Change')}
          type={ButtonType.link}
          action={() => {
            if (self.props.action) {
              self.props.action()
            }
          }}
        />
      </div>
    )
  }
}
